// lodash
import get from 'lodash/get';

export default () => ({
  ioBB: get(document.getElementById('ioBB'), 'value', null),
});
